<template>
    <label class="text-sm block text-cavilam-primary font-semibold" :class="class" :for="name">
        <span v-html="__(libelle)"></span>
        <sup v-if="required" class="text-red-500">*</sup>
    </label>
    <input v-model="$parent.form[name]"
       :class="{'border-red-500':$parent.form.errors[name]}"
       class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
       :id="name"
       :name="name"
       :type="type"
       :required="required"
       :readonly="readonly">
    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.ville_facturation}">
        {{ __($parent.form.errors.ville_facturation) }}
    </p>
</template>

<script>
export default {
    name: "InputForm",
    props: {
        name: {
            type: String,
            required: true
        },
        libelle: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'text'
        },
        required: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        class: {
            type: String,
            default: ''
        }
    },
}
</script>

<style scoped>

</style>
